<ng-container *ngIf="searchDisabled">
    <div class="custom-search-bar" (vrClickOutside)="closeDropdown()">
      <mat-icon class="search-icon" (click)="hideSearchBar()">search</mat-icon>
      <input
        type="search"
        class="search-input"
        placeholder="Search Anything..."
        [(ngModel)]="search"
        (input)="filterOption($event)"
        (keyup.enter)="onKeydown($event)"
        (focus)="openDropdown()"
        #inputElem
        autocomplete="off"
        spellcheck="false"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete class="mat-elevation-z2 autocmp" #auto="matAutocomplete">
        <mat-option
          *ngFor="let filter of filteredOptions"
          (keydown.enter)="getProducts(filter.name)"
          (click)="getProducts(filter.name)"
          [value]="filter.name"
        >
          <mat-icon>search</mat-icon>
          <span>{{ filter.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </div>
  </ng-container>
